import React from "react";

function Footer() {
  return (
    <div className="footer">
      <span>
        © 2012 - 2024 PSSM Dallas. All Rights Reserved
        {/* <div className="dev-by-bar">|</div> */}
        {/* <div className="dev-by">
          Developed by{" "}
          <a href="https://www.linkedin.com/in/satish-kumar-loka/">
            Satish Kumar Lokavarapu
          </a>
        </div> */}
      </span>
    </div>
  );
}

export default Footer;
